export default __webpack_public_path__ + "static/media/avatar_175.e7230597.png";